import { z } from "zod"

import { ProductOrigin } from "@/screens/Products/components/Product/Information/types/productOrigin"
import type { AutocompleteOption } from "@/types/form-fields"

const baseOriginSchema = z.object({
  exactLocation: z.string().nullable(),
  country: z.string().nullable().optional(),
  region: z.custom<AutocompleteOption>().nullable().optional(),
  city: z.string().nullable().optional(),
  originType: z.nativeEnum(ProductOrigin),
})

const originRefinement = {
  message: "If originType is 'supplier', exactLocation is required.",
  path: ["originType"],
}

const refinedOriginSchema = baseOriginSchema.refine(
  (data) =>
    (data.originType === ProductOrigin.SUPPLIER && !!data.exactLocation) || data.originType === ProductOrigin.OTHER,
  originRefinement
)

export const ProductOriginSchema = z.object({
  shippingOrigin: z.string().min(1, "Shipping origin is required"),
  manufacturingOrigin: refinedOriginSchema.nullable(),
  countryOrigin: refinedOriginSchema.nullable(),
})

export type ProductOriginFormSchema = z.infer<typeof ProductOriginSchema>
